import React, { Fragment, useEffect, useState } from "react";
import { tripColumns } from "../../../Data/Driver/DriverTrips";
import CommonDataTable from "../../Common/Component/CommonDataTable";
import { getDriverTrips } from "../../../Services/Driver.service";
import { showAlert } from "../../../Services/Shared.service";
import { Link } from "react-router-dom";
import moment from "moment";
import CommonToolTip from "../../Common/Component/CommonToolTip";
import StatusIcons from "../../../CommonElements/StatusIcons";
const DriverTrips = ({driverId}) => {
  const [tripData, setTripData] = useState([]);
  const [loading,setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    const obj = {
      driverId,
    };
    getDriverTrips(obj)
      .then((result) => {
        setLoading(false)
        if (result.data && result.data.length > 0) {
          const processData = result.data.map((element, index) => {
            return {
              booking_number: (
                <Link
                  // onClick={() =>
                  //   localStorage.setItem("prevLink", "booking/booking-history")
                  // }
                  to={`${process.env.PUBLIC_URL}/booking/booking-info/${element.booking.id}`}
                >
                  {element.megaCabsBookingNo}
                </Link>
              ),
              trip_date: element.tripStartTime
                ? moment(new Date(element.tripStartTime)).format(
                    "MMM DD HH:mm"
                  )
                : "-",
              pickup_time: element.pickUpDateTime
                ? moment(new Date(element.pickUpDateTime)).format(
                    "MMM DD HH:mm"
                  )
                : "-",
                pickupBooking_time: element.booking.pickUpDateTime
                ? moment(new Date(element.booking.pickUpDateTime)).format(
                    "MMM DD HH:mm"
                  )
                : "-",
              customer_name: element.custName ? element.custName : "-",
              phone_number: element.custMobile ? element.custMobile : "-",
              pickup_location: element.pickUpAddress
                ? // <>
                  //   <span id={"pickupLocation" + index}>{element.pickUpAddress}</span>
                  //   <CommonToolTip
                  //     options={{
                  //       placement: "left",
                  //       target: "pickupLocation" + index,
                  //     }}
                  //   >
                  //     {element.pickUpAddress}
                  //   </CommonToolTip>
                  // </>
                  element.pickUpAddress
                : "-",
              drop_location: element.destAddress ? (
                <>
                  <span id={"dropLocation" + index}>
                    {element.destAddress.includes("Kempegowda")
                      ? "Kempegowda Airport"
                      : element.destAddress}
                  </span>
                  <CommonToolTip
                    options={{
                      placement: "left",
                      target: "dropLocation" + index,
                    }}
                  >
                    {element.destAddress}
                  </CommonToolTip>
                </>
              ) : (
                "-"
              ),
              status: element?.currentTripStatusType ? (
                <>
                  <span className="status-icon">
                    <span id={"statusIcons" + index}>
                      <StatusIcons
                        statusType={element?.currentTripStatusType}
                      />
                    </span>
                    <CommonToolTip
                      options={{
                        placement: "left",
                        target: "statusIcons" + index,
                      }}
                    >
                      {element.currentTripStatusType}
                    </CommonToolTip>
                  </span>
                </>
              ) : (
                "-"
              ),
              booking_via: element.bookingViaType
                ? element.bookingViaType
                : "-",
            };
          });
          setTripData(processData);
        }
      })
      .catch((err) => {
        setLoading(false)
        showAlert("error", "Something went wrong");
      });
  }, []);
  return (
    <Fragment>
      <div className="table-responsive driver-trip-table">
        <CommonDataTable
          options={{
            columns: tripColumns,
            data: tripData,
            center: true,
          }}
          loading={loading}
        />
      </div>
    </Fragment>
  );
};

export default DriverTrips;
